export enum DeviceType {
	Desktop = 0,
	Phone = 10,
	Tablet = 20,
	Other = 30
}